/* -------------------------------------------------------

[ Custom settings ]

01. Preloader
02. Smoke Preloader
03. ScrollIt
04. Navbar scrolling background
05. Sections background image from data background
06. Animations
08. Testimonials owlCarousel
10. Clients owlCarousel
11. Gallery - Portfolio details owlCarousel
12. Blog owlCarousel
13. MagnificPopup Gallery
16. Faqs Accordion Box
18. Select2
19. Datepicker
22. Process accordion


------------------------------------------------------- */


$(function () {
    "use strict";
    // Preloader
    $("#preloader").fadeOut(400);
    $(".preloader-bg").delay(300).fadeOut(400);
    // Smoke Preloader
    setTimeout(function () {
        $('#preloader').fadeOut();
        $('.preloader-bg').fadeOut();
        $('.cd-transition-layer').addClass('closing').delay(1000).queue(function () {
            $(this).removeClass("visible closing opening").dequeue();
        });
    });
    let wind = $(window);

    // ScrollIt
    $.scrollIt({
        upKey: 38, // key code to navigate to the next section
        downKey: 40, // key code to navigate to the previous section
        easing: 'swing', // the easing function for animation
        scrollTime: 600, // how long (in ms) the animation takes
        activeClass: 'active', // class given to the active nav element
        onPageChange: null, // function(pageIndex) that is called when page is changed
        topOffset: -70 // offste (in px) for fixed top navigation
    });

    // Registering middleclick listener
    $(document).on("mouseup", function (e) {
        if (e.which === 2) {
            let e2 = $.event.fix(e);
            e2.type = "middleclick";
            $(e.target).trigger(e2);
        }
    });

    // Mobile pushy menu
    wind.on("load resize", function () {
        if (wind.width() >= 768) {
            $('body').removeClass("pushy-open-right");
        }
    })

    // Navbar scrolling background
    wind.on("scroll", function () {
        var bodyScroll = wind.scrollTop(),
            navbar = $(".navbar"),
            logo = $(".navbar .logo> img");
        if (bodyScroll > 100) {
            navbar.addClass("nav-scroll");
        } else {
            navbar.removeClass("nav-scroll");
        }
    });
    // close navbar-collapse when a  clicked
    $(".navbar-nav .dropdown-item a").on('click', function () {
        $(".navbar-collapse").removeClass("show");
    });

    // Sections background image from data background
    var pageSection = $(".bg-img, section");
    pageSection.each(function (indx) {
        if ($(this).attr("data-background")) {
            $(this).css("background-image", "url(" + $(this).data("background") + ")");
        }
    });

    // Animations
    var contentWayPoint = function () {
        var i = 0;
        $('.animate-box').waypoint(function (direction) {
            if (direction === 'down' && !$(this.element).hasClass('animated')) {
                i++;
                $(this.element).addClass('item-animate');
                setTimeout(function () {
                    $('body .animate-box.item-animate').each(function (k) {
                        var el = $(this);
                        setTimeout(function () {
                            var effect = el.data('animate-effect');
                            if (effect === 'fadeIn') {
                                el.addClass('fadeIn animated');
                            } else if (effect === 'fadeInLeft') {
                                el.addClass('fadeInLeft animated');
                            } else if (effect === 'fadeInRight') {
                                el.addClass('fadeInRight animated');
                            } else {
                                el.addClass('fadeInUp animated');
                            }
                            el.removeClass('item-animate');
                        }, k * 200, 'easeInOutExpo');
                    });
                }, 100);
            }
        }, {
            offset: '85%'
        });
    };
    $(function () {
        contentWayPoint();
    });

    // Testimonials owlCarousel
    $('.testimonials .owl-carousel').owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: false,
        dots: false,
        nav: false,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });

    // Clients owlCarousel
    $('.clients .owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: true,
        dots: false,
        responsiveClass: true,
        responsive: {
            0: {
                margin: 10,
                items: 3
            },
            600: {
                items: 4
            },
            1000: {
                items: 5
            }
        }
    });

    // Gallery - Portfolio details owlCarousel
    $('.gallery .owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: false,
        dots: false,
        nav: false,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });

    // Blog owlCarousel
    $('.blog .owl-carousel').owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: false,
        dots: true,
        nav: false,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 2
            }
        }
    });

    // MagnificPopup Gallery
    $(".img-zoom").magnificPopup({
        type: "image",
        closeOnContentClick: !0,
        mainClass: "mfp-fade",
        gallery: {
            enabled: !0,
            navigateByImgClick: !0,
            preload: [0, 1]
        },
        callbacks: {
            open: function () {
                $('body').addClass('mfp-opened');
            },
            close: function () {
                $('body').removeClass('mfp-opened');
            }
        }
    });

    $('.instagram-carousel').each(function () {
        $(this).find('.single-instagram-post')
            .on('auxclick click', function (e) {
                e.preventDefault();
            })
            .on('middleclick', function (e) {
                window.open($(this).attr('data-permalink'));
            });

        $(this).magnificPopup({
            type: 'image',
            delegate: 'a',
            mainClass: 'mfp-fade',
            gallery: {
                enabled: true,
                navigateByImgClick: false,
            },
            removalDelay: 300,
            preloader: false,
            preload: [0, 0],
            fixedContentPos: false,
            callbacks: {
                buildControls: function() {

                    let dots = $("<div class='mfp-dots'></div>");

                    let popup = this;

                    popup._checkIfClose = function(target) {

                        if($(target).hasClass('mfp-prevent-close')) {
                            return;
                        }

                        let closeOnContent = popup.st.closeOnContentClick;
                        let closeOnBg = popup.st.closeOnBgClick;

                        if(closeOnContent && closeOnBg) {
                            return true;
                        } else {

                            // We don't close the popup if click is on navigation dots
                            if($(target).hasClass('mfp-dots') || $(target).hasClass('mfp-dot')) {
                                return false;
                            }

                            // We close the popup if click is on close button or on preloader. Or if there is no content.
                            if(!popup.content || $(target).hasClass('mfp-close') || (popup.preloader && target === popup.preloader[0]) ) {
                                return true;
                            }

                            // if click is outside the content
                            if(  (target !== popup.content[0] && !$.contains(popup.content[0], target))  ) {
                                if(closeOnBg) {
                                    // last check, if the clicked element is in DOM, (in case it's removed onclick)
                                    if( $.contains(document, target) ) {
                                        return true;
                                    }
                                }
                            } else if(closeOnContent) {
                                return true;
                            }

                        }
                        return false;
                    };

                    let children = Object.values(popup.st.items).slice(0, popup.st.items.length);

                    children.forEach((item, index)  => {
                        dots.append("<button type='button' class='mfp-dot' aria-label='post "+index+"' data-index='"+index+"'></button>");
                    });

                    popup.contentContainer.append(dots);
                },
                open: function () {
                    $('body').addClass('mfp-opened mfp-carousel-opened');
                },
                close: function () {
                    $('body').removeClass('mfp-opened mfp-carousel-opened');
                },
                imageLoadComplete: function () {
                    let popup = this;
                    let currItem = popup.currItem;

                    $(currItem.img).on('click middleclick', function () {
                        window.open(currItem.el.attr('data-permalink'));
                    });

                    popup.contentContainer.append(popup.arrowLeft.add(popup.arrowRight));

                    popup.contentContainer.find(".mfp-dots .mfp-dot").removeClass('mfp-dot-active');
                    popup.contentContainer.find(".mfp-dots .mfp-dot[data-index="+currItem.index+"]").addClass('mfp-dot-active');

                    popup.contentContainer.find(".mfp-dots .mfp-dot").on('click', function () {
                        popup.goTo(Number($(this).attr('data-index')));
                        popup.updateItemHTML();
                    });
                }
            }
        })
    });

    $('.magnific-youtube, .magnific-vimeo, .magnific-custom').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 300,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
            open: function () {
                $('body').addClass('mfp-opened');
            },
            close: function () {
                $('body').removeClass('mfp-opened');
            }
        }
    });

    // Faqs Accordion Box
    if ($(".accordion-box").length) {
        $(".accordion-box").on("click", ".acc-btn", function () {
            var outerBox = $(this).parents(".accordion-box");
            var target = $(this).parents(".accordion");
            if ($(this).next(".acc-content").is(":visible")) {
                //return false;
                $(this).removeClass("active");
                $(this).next(".acc-content").slideUp(300);
                $(outerBox).children(".accordion").removeClass("active-block");
            } else {
                $(outerBox).find(".accordion .acc-btn").removeClass("active");
                $(this).addClass("active");
                $(outerBox).children(".accordion").removeClass("active-block");
                $(outerBox).find(".accordion").children(".acc-content").slideUp(300);
                target.addClass("active-block");
                $(this).next(".acc-content").slideDown(300);
            }
        });
    }

    // Select2
    $('.select2').select2({
        minimumResultsForSearch: Infinity,
    });

    // Datepicker
    $(".datepicker").datepicker({
        orientation: "top"
    });

    // Process Accordion
    if ($(".accordion-grp").length) {
        var accordionGrp = $(".accordion-grp");
        accordionGrp.each(function () {
            var accordionName = $(this).data("grp-name");
            var Self = $(this);
            var accordion = Self.find(".accordion");
            Self.addClass(accordionName);
            Self.find(".accordion .accordion-content").hide();
            Self.find(".accordion.active").find(".accordion-content").show();
            accordion.each(function () {
                $(this).find(".accordion-title").on("click", function () {
                    if ($(this).parent().hasClass("active") === false) {
                        $(".accordion-grp." + accordionName).find(".accordion").removeClass("active");
                        $(".accordion-grp." + accordionName).find(".accordion").find(".accordion-content").slideUp();
                        $(this).parent().addClass("active");
                        $(this).parent().find(".accordion-content").slideDown();
                    }
                });
            });
        });
    }
    //  Pricing Accordion
    $(".accordion").on("click", ".title", function () {
        $(this).next().slideDown();
        $(".accordion-info").not($(this).next()).slideUp();
    });
    $(".accordion").on("click", ".item", function () {
        $(this).addClass("active").siblings().removeClass("active");
    });
});
